import Stack from '@mui/material/Stack';
import { ShowDate } from 'framework/ui/ui-builder';
import { FieldProps, useFieldHelper } from 'framework/ui/field';
import { Badge, BadgeProps } from 'framework/ui/mui-builder';
import { DATE_FORMAT } from 'framework/utils';
import { COMPLIANCE_CONTROL_STATUS } from '../../constants';
import { ComplianceControlLatestCheck, ComplianceControlStatus } from '../../types';

interface ComplianceControlLastCheckFieldProps extends FieldProps<ComplianceControlStatus> {
  latestSource: string;
  lastCheckedAtSource: string;
}

const STATUS_COLORS: Record<ComplianceControlStatus, BadgeProps['color']> = {
  [COMPLIANCE_CONTROL_STATUS.PASS]: 'success',
  [COMPLIANCE_CONTROL_STATUS.FAIL]: 'error',
  [COMPLIANCE_CONTROL_STATUS.TECHNICAL_FAILURE]: 'warning',
};

/** The newest decision (status + date) — a scanning aid, not the verdict (see the Status column). */
const ComplianceControlLastCheckField = ({ source, latestSource, lastCheckedAtSource }: ComplianceControlLastCheckFieldProps) => {
  const { getValue: getLatest } = useFieldHelper<ComplianceControlLatestCheck | null>({ source: latestSource });
  const { getValue: getLastStatus } = useFieldHelper<ComplianceControlStatus | null>({ source });
  const { getValue: getLastCheckedAt } = useFieldHelper<string | null>({ source: lastCheckedAtSource });

  const latest = getLatest();
  const status = latest?.status ?? getLastStatus();
  const evaluatedAt = latest?.evaluatedAt ?? getLastCheckedAt();

  if (!status && !evaluatedAt) return <span>Never</span>;

  return (
    <Stack spacing={0.5} alignItems="flex-start">
      {status && <Badge color={STATUS_COLORS[status]}>{status}</Badge>}
      {evaluatedAt && <ShowDate dateUTC={evaluatedAt} format={DATE_FORMAT.FULL} variant="caption" />}
    </Stack>
  );
};

export default ComplianceControlLastCheckField;
